"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideObjectAttributes = void 0;
const { NODE_ENV, REACT_APP_PROJECT_CODE, REACT_APP_DEPLOYMENT_STAGE, ECS_TASK_ARN, AWS_SESSION_TOKEN } = process.env;
const isReact = (NODE_ENV === 'development' || NODE_ENV === 'production' || NODE_ENV === 'test') && !!REACT_APP_PROJECT_CODE && !!REACT_APP_DEPLOYMENT_STAGE;
const debug = !(isReact || ECS_TASK_ARN || AWS_SESSION_TOKEN) && false;
/**
 * **MUTATES** {@link overridableObject} with any common attribute overridden from {@link overridingObject}
 *
 * Recurses where the same attribute is an `object` or array (`[]`), but not a primative
 *
 * - Any attributes in {@link overridableObject} but not in {@link overridingObject} are left untouched
 * - Any common attributes are overridden
 * - any non-present attributes in {@link overridableObject} but present in {@link overridingObject} are added
 *
 * Essentially, a merge with {@link overridingObject} taking precendence
 */
const overrideObjectAttributes = ({ overridableObject, overridingObject }) => {
    try {
        Object.entries(overridingObject).forEach(([k, v]) => {
            if (v instanceof Array) {
                if (overridableObject[k] instanceof Array) {
                    if (!overridableObject[k] || !(overridableObject[k] instanceof Array)) {
                        overridableObject[k] = [];
                    }
                    (0, exports.overrideObjectAttributes)({ overridableObject: overridableObject[k], overridingObject: v });
                }
                else {
                    // if a.k isn't array make it so
                    overridableObject[k] = v;
                }
            }
            else if (typeof v === 'object') {
                if (!!v) {
                    if (!overridableObject[k]) {
                        overridableObject[k] = {};
                    }
                    (0, exports.overrideObjectAttributes)({ overridableObject: overridableObject[k], overridingObject: v });
                }
                else {
                    // nulls are overriden
                    overridableObject[k] = v;
                }
            }
            else {
                if (v) {
                    if (overridableObject[k] !== v) {
                        debug && console.log(`Overriding ${k} from ${overridableObject[k]} to ${v}`);
                        overridableObject[k] = v;
                    }
                }
                else {
                    debug && console.log(`Not overriding ${k} as value is falsy (${v})`);
                }
            }
        });
    }
    catch (e) {
        console.log({ overridableObject, overridingObject });
        throw new Error(`Can't override: ${e.message} `);
    }
};
exports.overrideObjectAttributes = overrideObjectAttributes;
